import BusinessIcon from '@mui/icons-material/Business';
import PersonIcon from '@mui/icons-material/Person';
import { Chip, Stack, alpha } from '@mui/material';
import _ from 'lodash';
import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { BlacklistTypes } from './company-blacklist.types';

interface Props {
  label: string;
  blacklistType: BlacklistTypes;

  handleRemove(): void;
}

const BlacklistItemChip: React.FC<Props> = ({ label, blacklistType, handleRemove }) => {
  const { classes } = useStyles();

  return (
    <>
      <Chip
        className={classes.chip}
        variant={'outlined'}
        size={'small'}
        label={
          !_.isNil(blacklistType) ? (
            <Stack direction={'row'} alignItems={'center'} gap={0.5}>
              {blacklistType === BlacklistTypes.CONTACT ? (
                <PersonIcon className={classes.icon} />
              ) : blacklistType === BlacklistTypes.COMPANY ? (
                <BusinessIcon className={classes.icon} />
              ) : null}{' '}
              {label}
            </Stack>
          ) : (
            label
          )
        }
        onDelete={handleRemove}
      />
    </>
  );
};

const useStyles = makeStyles()((theme) => ({
  chip: {
    borderColor: theme.palette.greys.light,
    borderRadius: '6px',
    backgroundColor: '#FFF',
    '&.exclude': {
      background: alpha(theme.palette.error.main, 0.2),
      borderColor: theme.palette.error.main,
      '& .MuiSvgIcon-root': {
        color: theme.palette.error.main,
      },
    },
    '& .MuiSvgIcon-root': {
      color: theme.palette.primary.main,
    },
    '& .MuiSvgIcon-root:hover': {
      color: theme.palette.secondary.main,
    },
  },
  icon: {
    fontSize: theme.typography.pxToRem(16),
    color: theme.palette.primary.main,
  },
}));

export default BlacklistItemChip;
